module.exports = __webpack_public_path__ + "img/banner_mobile_3.d85965d5.jpeg";